import {ConfigKeys} from '@drl/core/enums/config-keys.enum';

export class TenantConfig {
  id?: number;
  configKey?: ConfigKeys;
  configValue?: object;
}

export class SATenantConfig {
  phone: string;
  supportEmail: string;
}

export class MasterTenantConfig{
  id?: number;
  configKey?: ConfigKeys;
  configValue?: object;
  otherConfigs?:object;

}
